// Mock data for Beyond the Path - Christmas Markets Tour

export const HERO_IMAGE = "https://images.unsplash.com/photo-1602521878553-8268e4c6f72d?auto=format&fit=crop&w=2000&q=80";

export const cities = [
  {
    name: "London",
    country: "United Kingdom",
    image: "https://images.unsplash.com/photo-1514729797186-944d57303199?auto=format&fit=crop&w=1200&q=80",
    blurb: "West End sparkle, Hyde Park Winter Wonderland, and Covent Garden charm.",
    days: "Days 1 – 4"
  },
  {
    name: "Brussels",
    country: "Belgium",
    image: "https://images.unsplash.com/photo-1640082937167-ea3206ec4524?auto=format&fit=crop&w=1200&q=80",
    blurb: "Grand Place light shows, waffles, frites and the Winter Wonders market.",
    days: "Days 4 – 6"
  },
  {
    name: "Bruges",
    country: "Belgium",
    image: "https://images.unsplash.com/photo-1606080229480-b33e8a317a4b?auto=format&fit=crop&w=1200&q=80",
    blurb: "A storybook medieval town wrapped in twinkling lights and cobblestones.",
    days: "Day Trip"
  },
  {
    name: "Paris",
    country: "France",
    image: "https://images.unsplash.com/photo-1512991812186-4f940b265125?auto=format&fit=crop&w=1200&q=80",
    blurb: "Tuileries market, illuminated Eiffel Tower, and Champs-Élysées magic.",
    days: "Days 7 – 10"
  },
  {
    name: "Strasbourg",
    country: "France",
    image: "https://images.unsplash.com/photo-1701943523362-4fc34a738dc4?auto=format&fit=crop&w=1200&q=80",
    blurb: "The self-proclaimed Capital of Christmas with Alsatian charm.",
    days: "Day Trip"
  }
];

export const itinerary = [
  {
    day: "Day 0",
    date: "Thursday, December 3",
    title: "Depart the USA",
    location: "Los Angeles → London",
    bullets: [
      "Depart Los Angeles (LAX) on an overnight flight to London (LHR)."
    ]
  },
  {
    day: "Day 1",
    date: "Friday, December 4",
    title: "Arrive in London",
    location: "London, UK",
    bullets: [
      "Arrive London (LHR) before 11:30 AM to meet your tour guide and transfer to your hotel.",
      "Afternoon at Covent Garden — giant ornaments, performers and boutique shops.",
      "Evening stroll to Trafalgar Square and Leicester Square Christmas Market for mulled wine."
    ]
  },
  {
    day: "Day 2",
    date: "Saturday, December 5",
    title: "Classic London Highlights",
    location: "London, UK",
    bullets: [
      "Tower of London and Tower Bridge along the Thames.",
      "Southbank Christmas Market for global street food and riverside mulled wine.",
      "Oxford Street & Regent Street light displays in the evening."
    ]
  },
  {
    day: "Day 3",
    date: "Sunday, December 6",
    title: "Markets & Iconic Sights",
    location: "London, UK",
    bullets: [
      "Westminster Abbey, Big Ben and the Houses of Parliament.",
      "Hyde Park Winter Wonderland — rides, skating and themed bars.",
      "Dinner in Soho followed by Carnaby Street’s creative Christmas lights."
    ]
  },
  {
    day: "Day 4",
    date: "Monday, December 7",
    title: "Eurostar to Brussels",
    location: "Brussels, Belgium",
    bullets: [
      "Eurostar from London St Pancras to Brussels (≈2 hrs).",
      "Grand Place light show and Galeries Royales Saint-Hubert.",
      "Evening at Winter Wonders — waffles, frites, chocolate and glühwein."
    ]
  },
  {
    day: "Day 5",
    date: "Tuesday, December 8",
    title: "Day Trip to Bruges",
    location: "Bruges, Belgium",
    bullets: [
      "Train to Bruges (1 hr) — explore Markt Square.",
      "Bruges Christmas Market among cobblestones and gingerbread façades.",
      "Optional Belfry Tower climb; return to Brussels for a cozy dinner."
    ]
  },
  {
    day: "Day 6",
    date: "Wednesday, December 9",
    title: "Brussels at Leisure",
    location: "Brussels, Belgium",
    bullets: [
      "Atomium, Royal Palace or comic-strip murals at your pace.",
      "Shop the Sablon district for artisanal Belgian chocolates.",
      "Final evening browsing the markets and lights."
    ]
  },
  {
    day: "Day 7",
    date: "Thursday, December 10",
    title: "High-Speed to Paris",
    location: "Paris, France",
    bullets: [
      "Train from Brussels to Paris (≈1h22). Check in near Saint-Germain, Marais or Opéra.",
      "Tuileries Garden Christmas Market — warm drinks and French crafts.",
      "Seine-side walk with the Eiffel Tower sparkling on the hour."
    ]
  },
  {
    day: "Day 8",
    date: "Friday, December 11",
    title: "Day Trip to Strasbourg",
    location: "Strasbourg, France",
    bullets: [
      "Train to Strasbourg (≈1h50) — the Capital of Christmas.",
      "Christkindelsmärik around the Cathedral and storybook Petite France.",
      "Alsatian flammekueche and vin chaud before returning to Paris."
    ]
  },
  {
    day: "Day 9",
    date: "Saturday, December 12",
    title: "Final Day in Paris",
    location: "Paris, France",
    bullets: [
      "Louvre or Musée d’Orsay (admissions not included).",
      "Montmartre village streets and the market near Sacré-Cœur.",
      "Farewell evening on the Champs-Élysées with grand Christmas lights."
    ]
  },
  {
    day: "Day 10",
    date: "Sunday, December 13",
    title: "Depart for LAX",
    location: "Paris → Los Angeles",
    bullets: [
      "Transfer to Paris Charles de Gaulle (CDG) for your flight home.",
      "Carry home the magic of Europe’s most enchanting Christmas markets."
    ]
  }
];

export const included = [
  "9 nights in cozy 3–4 star hotels with daily breakfast",
  "All inter-city train transport (Eurostar & high-speed)",
  "Guided experiences at iconic Christmas markets",
  "Day trips to Bruges and Strasbourg",
  "Intimate ladies-only small-group atmosphere",
  "24/7 on-tour support from your guide Sophia"
];

export const notIncluded = [
  "Round-trip airfare to London & from Paris (~$1,000 estimate)",
  "Lunches, dinners and snacks (breakfast included)",
  "Travel insurance — strongly recommended",
  "Museum admissions & optional activities",
  "Personal expenses, gifts and souvenirs"
];

export const tripFacts = {
  duration: "10 Days / 9 Nights",
  startCity: "London, UK",
  endCity: "Paris, France",
  dates: "December 3 – 13, 2026",
  groupSize: "Small Group",
  price: "$2,695",
  deposit: "$200"
};

export const galleryDetails = [
  "https://images.unsplash.com/photo-1636975033611-935e3f5efaa1?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1549699143-b6bf1cde4605?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1512991812186-4f940b265125?auto=format&fit=crop&w=1200&q=80"
];

export const guide = {
  name: "Sophia Borkgren",
  role: "Tour Founder & Guide",
  phone: "818-825-4308",
  email: "sophiaborkgren@gmail.com",
  image: "/sophia_6448a85ef1566556d7a32940e2789fe1.jpg",
  gallery: [
    "/sophia_ab9ee90fcc767556b3e27e8f4253d332.jpg",
    "/sophia_73d7cb4706e39916ac75dc9df41492e5.jpg",
    "/sophia_0bc6301b25d7fa1fd94bad6a605026d2.jpg"
  ],
  bio: [
    "My love for travel began right after high school on a European trip with Buzz’s Tours, where I discovered the pure joy of exploring new places with amazing people.",
    "After college at CU Boulder, I packed my bags and spent two years traveling through South America and Southeast Asia, soaking up every culture and adventure along the way.",
    "While studying abroad, I fell in love with Central Europe’s winter magic — the festive markets, the cozy vibes, the snowy charm — and I knew I had to bring a group of incredible women to experience it with me."
  ]
};

export const testimonials = [
  {
    quote: "This Christmas market trip was absolutely magical! All the cities we visited were beautifully decorated and the food and drink were delicious. A wonderful balance of planned activities and free time — a trip of a lifetime I will never forget!",
    name: "Pam H.",
    trip: "Christmas Markets 2025"
  },
  {
    quote: "Beyond the Path provided a way to see the Christmas markets in a stress-free, easy-going environment. Everything was planned and included, and Sophia made it fun and magical. I loved every moment.",
    name: "Kimmy C.",
    trip: "Christmas Markets 2025"
  },
  {
    quote: "My first time ever visiting Europe — and this trip exceeded every expectation. Sophia was an amazing host who planned every day to include beautiful sights and flexibility to explore on your own.",
    name: "Breanna A.",
    trip: "Christmas Markets 2025"
  },
  {
    quote: "It was a breeze to travel from city to city — transportation and accommodations were all pre-arranged. The friendships I formed and the memories we made will last a lifetime. I can’t wait to travel with Beyond the Path again!",
    name: "Sherri B.",
    trip: "Christmas Markets 2025"
  },
  {
    quote: "So well thought out. Sophia was an incredible leader — organized, with options for as many or as few activities as you wanted. And the group of ladies couldn’t have been kinder or more fun. What a memorable experience!",
    name: "Paula W.",
    trip: "Christmas Markets 2025"
  },
  {
    quote: "Once-in-a-lifetime experience. I enjoyed quality time with my daughter and siblings — all the women in our group were incredible. Well planned and thought out, from hotels to transportation. Well done Sophia!",
    name: "Jhoanna A.",
    trip: "Christmas Markets 2025"
  },
  {
    quote: "Simply unforgettable all the way around.",
    name: "Lisa H.",
    trip: "Christmas Markets 2025"
  },
  {
    quote: "BEST TRIP EVER!! Need less sleep, more time at the markets.",
    name: "Anonymous Traveler",
    trip: "Christmas Markets 2025"
  }
];
